// inventorySparesApiSlice.js
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../../apiSlice";

/* ------------------ Adapter ------------------ */
const inventorySparesAdapter = createEntityAdapter({
  selectId: (item) => item.request_id,
});

const initialState = inventorySparesAdapter.getInitialState();

/* ------------------ API Slice ------------------ */
export const inventorySparesListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInventorySparesList: builder.query({
      query: ({ seller_id, status } = {}) => {
        let queryString = "/inventory/spares";
        const params = new URLSearchParams();

        if (seller_id) params.append("seller_id", seller_id);
        if (status) params.append("status", status);

        if (params.toString()) {
          queryString += `?${params.toString()}`;
        }

        return queryString;
      },

      transformResponse: (response) =>
        inventorySparesAdapter.setAll(initialState, response.data),

      providesTags: (result) =>
        result
          ? [
              { type: "InventorySpare", id: "LIST" },
              ...result.ids.map((id) => ({ type: "InventorySpare", id })),
            ]
          : [{ type: "InventorySpare", id: "LIST" }],
    }),
  }),
});

export const { useGetInventorySparesListQuery } = inventorySparesListSlice;

const inventorySpareFilter = (state) => state.inventorySpareFilter;
const selectInventorySparesQueryResult = createSelector(
  [inventorySpareFilter, (state) => state],
  (filters, state) => {
    // select query result for current filters
    const result =
      inventorySparesListSlice.endpoints.getInventorySparesList.select({
        seller_id: filters.seller_id,
        status: filters.status,
      })(state);
    return result;
  }
);

const selectInventorySparesData = createSelector(
  [selectInventorySparesQueryResult],
  (queryResult) => queryResult?.data ?? initialState
);

/* ------------------ Export Entity Adapter Selectors ------------------ */
export const {
  selectAll: selectInventorySpares,
  selectById: selectInventorySpareById,
  selectIds: selectInventorySpareIds,
} = inventorySparesAdapter.getSelectors((state) => {
  const data = selectInventorySparesData(state);
  return data;
});
